import React, { FC, useState, useContext, useEffect } from "react";
import { Container, layout, tailLayout, submitContainer } from "./loginStyles";
import { Form, Input, Button, Alert, Card, Avatar } from "antd";
import { useFormik, FormikValues } from "formik";
import { loginRequest } from "api/Api";
import * as Yup from "yup";
import { useHistory } from "react-router-dom";
import { login } from "contexts/auth/Actions";
import { Context } from "contexts/Provider";
import logo from "../../assets/logo.png";

interface ILoginViewProps {}

const LoginSchema = Yup.object().shape({
  email: Yup.string().email("Invalid E-Mail.").required("E-Mail required."),
  password: Yup.string().required("Password required."),
});

const LoginPage: FC<ILoginViewProps> = () => {
  const {
    state: { auth },
    dispatch,
  } = useContext(Context);

  const [error, setError] = useState<string>("");

  const history = useHistory();

  useEffect(() => {
    if (auth.isLoggedIn) history.push("/");
  }, []);

  const handleLogin = async (v: FormikValues) => {
    try {
      setError("");
      const response = await loginRequest({
        email: v.email,
        password: v.password,
      });
      dispatch(login(response));
      history.push("/");
    } catch (e) {
      setError("Wrong e-mail or password.");
    }
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: LoginSchema,
    onSubmit: handleLogin,
  });

  const { values, errors, touched, handleChange, handleSubmit, isSubmitting } =
    formik;

  return (
    <Container>
      <Card>
        <Form
          {...layout}
          name="Login Form"
          initialValues={{ remember: true }}
          onFinish={handleSubmit}
        >
          <Avatar size={50} src={logo} />
          <h1>Login</h1>
          <Form.Item
            validateStatus={errors.email && touched.email ? "error" : "success"}
            help={errors.email && touched.email ? errors.email : null}
          >
            <Input
              autoFocus
              placeholder="E-mail"
              name="email"
              value={values.email}
              onChange={handleChange}
            />
          </Form.Item>
          <Form.Item
            validateStatus={
              errors.password && touched.password ? "error" : "success"
            }
            help={errors.password && touched.password ? errors.password : null}
          >
            <Input.Password
              placeholder="Password"
              name="password"
              value={values.password}
              onChange={handleChange}
            />
          </Form.Item>
          {error ? (
            <Form.Item {...tailLayout}>
              <Alert type="error" message={error} />
            </Form.Item>
          ) : null}
          <Form.Item {...tailLayout} {...submitContainer}>
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              Login
            </Button>
          </Form.Item>
          <Button
            type="link"
            onClick={() => {
              history.push("/register");
            }}
          >
            Register
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default LoginPage;
